import ApiRequest from "../axiosInstance/request";
import { endpoints } from "../endpoints";
import axiosInstance from "../axiosInstance";

export const ContentBuyerList = async (data) => {
  console.warn(
    "🚀 ~ file: editor.api.ts:16 ~ ContentBuyerList ~ dataasdasd:",
    data
  );

  return new Promise((resolve, reject) => {
    ApiRequest.get(
      `${endpoints.buyer.buyerList}?status=${data?.status}&search=${data?.search}&from=${data?.startDate}&to=${data?.endDate}&page=${data?.pageParam}`
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const contentBuyerVideoList = (datas) => {
  function buildQueryString() {
    const queryParts = [];

    for (const key in datas) {
      // console.warn("key", key);
      if (
        key !== "null" &&
        datas.hasOwnProperty(key) &&
        datas[key] !== null &&
        datas[key] !== undefined
      ) {
        const value = encodeURIComponent(datas[key]);
        queryParts.push(`${key}=${value}`);
      }
    }

    return queryParts.join("&");
  }

  try {
    // console.warn("call-----------------------------------------------------------------------------------------------");
    let queryString = buildQueryString();
    console.warn("queryString-------------", queryString);

    const res = axiosInstance.get(`${endpoints.videos.videos}?${queryString}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const ContentBuyerExpenses = async (data) => {
  return new Promise((resolve, reject) => {
    ApiRequest.post(endpoints.expense.expense, data)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const fetchContentBuyers = () => {
  return new Promise((resolve, reject) => {
    ApiRequest.post(endpoints.users.byRole, { role: [9] })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
